import instance from "./baseRequest";

export const contactSettingsApi = {
  getSettings: () => instance.get("/contact/settings"),
  createSettings: (data) => instance.post("/contact/settings", data),
  updateSettings: (data) => instance.put("/contact/settings", data),
};
